import configureStore from './config/configureStore';

const initialState = {};
const store = configureStore(initialState);

export default store;
